import { Chip, Divider, Stack } from '@mui/material';
import { SelectedChipProps } from './types';

// Selecting every employee of a large company used to render a chip per selection, which grew the
// row unbounded and pushed the surrounding modal past its own max height.
const CHIP_LIMIT = 20;

export const SelectedChips = (props: SelectedChipProps): JSX.Element => {
  const { selected, onRemove } = props;

  if (selected.length === 0) return null;

  const shown = selected.slice(0, CHIP_LIMIT);
  const hiddenCount = selected.length - shown.length;

  return (
    <>
      <Divider />
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {shown.map(o => (
          <Chip key={o.value} label={o.label} onDelete={() => onRemove(o.value)} size="small" />
        ))}
        {hiddenCount > 0 && <Chip label={`+${hiddenCount}`} size="small" variant="outlined" />}
      </Stack>
    </>
  );
};
